import { EdgeRecordConnectEulaAcceptanceRepository } from '@/modules/connect/infra'
import type { RecordConnectEulaAcceptance } from '@/modules/connect/use-cases'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeRecordConnectEulaAcceptance(): RecordConnectEulaAcceptance {
  return new EdgeRecordConnectEulaAcceptanceRepository(makeSupabaseEdgeHttpClient()).execute
}
